import MentoringTopCard from './MentoringTopCard.vue';

export default MentoringTopCard;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/programcard/components/top/index.ts